import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const PROCESS_ODOO_INVOICE_CLIENT_RESET   = 'PROCESS_ODOO_INVOICE_CLIENT_RESET';
export const PROCESS_ODOO_INVOICE_CLIENT_LOADING = 'PROCESS_ODOO_INVOICE_CLIENT_LOADING';
export const PROCESS_ODOO_INVOICE_CLIENT_SUCCESS = 'PROCESS_ODOO_INVOICE_CLIENT_SUCCESS';
export const PROCESS_ODOO_INVOICE_CLIENT_REJECT  = 'PROCESS_ODOO_INVOICE_CLIENT_REJECT';

//* ACTIONS ------------------------------------------------
export const processOdooInvoiceClientReset   = () => ({ type: PROCESS_ODOO_INVOICE_CLIENT_RESET });
export const processOdooInvoiceClientLoading = () => ({ type: PROCESS_ODOO_INVOICE_CLIENT_LOADING });
export const processOdooInvoiceClientSuccess = (payload) => ({ type: PROCESS_ODOO_INVOICE_CLIENT_SUCCESS, payload });
export const processOdooInvoiceClientReject  = (payload) => ({ type: PROCESS_ODOO_INVOICE_CLIENT_REJECT,  payload });

//* REQUEST SERVICE ----------------------------------------
export const processOdooInvoiceClientRequest = async (InvoiceId, getState) => {
    const options = await withToken({
        method: Methods.POST,
    }, getState);
    return request(`/Invoices/web/AddInvoicesToOdoo/${InvoiceId}`, options);
};
